// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivity-cls1_fr0","cls2":"CollapsedActivity-cls2_dju CollapsedActivity-cls1_fr0"};